import React from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from "moment";

import PopupCustomized from '../../../../../components/PopupCustomized';
import DateRangePicker from '../../../../../components/v3/DateRangePicker/DateRangePicker';
import GeneralQuestionCodeChartContainer from '../../../../../components/v3/Graphs/ChartContainer/GeneralQuestionCodeChartContainer';
import FilterArrow from '../../../../../icons/v3/FilterArrow';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import HelpOutline from '@material-ui/icons/HelpOutline';

import SelectTable from '../../../../../components/v3/CalibrationScreenV3/SelectTable';
import { dateFormat, filterType, timePeriodicityOptions } from '../../../../../constants';
import { isDefined, cloneArray, arrayIsNotEmpty } from '../../../../../utils';

import {
    updateProps,
    loadProgressOverTimeStats,
} from '../../CalibrationV3ScreenActions';

class TeamOverTimeGraphs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSelectReasonsForContactPopup: false,
            showSelectChannelPopup: false,
            selectedAgents: undefined,
            selectedReasonForContact: undefined,
            selectedChannel: undefined,
            fromDate: undefined, //moment().subtract(7, 'd').format(dateFormat),
            toDate: moment().format(dateFormat),
            selectedTimePeriodicity: "Daily",
            mouseClickX: 100,
            mouseClickY: 100,
        };

        this.showSelectReasonsForContactPopup = this.showSelectReasonsForContactPopup.bind(this);
        this.hideSelectReasonsForContactPopup = this.hideSelectReasonsForContactPopup.bind(this);

        this.getSelectReasonForContactPopup = this.getSelectReasonForContactPopup.bind(this);
        this.getSelectChannelPopup = this.getSelectChannelPopup.bind(this);

        this.showSelectChannelPopup = this.showSelectChannelPopup.bind(this);
        this.hideSelectChannelPopup = this.hideSelectChannelPopup.bind(this);

        this.getSelectedReasonForContactNode = this.getSelectedReasonForContactNode.bind(this);
        this.getSelectedChannelNode = this.getSelectedChannelNode.bind(this);

        this.getDateFiltersNode = this.getDateFiltersNode.bind(this);

        this.removeReasonForContact = this.removeReasonForContact.bind(this);
        this.removeAgent = this.removeAgent.bind(this);
        this.removeChannel = this.removeChannel.bind(this);

        this.setNewTimeRangeForProgressOverTime = this.setNewTimeRangeForProgressOverTime.bind(this);
        this.onSelectNewTimePeriodicity = this.onSelectNewTimePeriodicity.bind(this);
        this.onSelectDateRange = this.onSelectDateRange.bind(this);

        this.showProgressOverTimeHelpPopup = this.showProgressOverTimeHelpPopup.bind(this);
        this.closeProgressOverTimeHelpPopup = this.closeProgressOverTimeHelpPopup.bind(this);
    }

    showProgressOverTimeHelpPopup(e) {
        this.setState({ showProgressOverTimeHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeProgressOverTimeHelpPopup() {
        this.setState({ showProgressOverTimeHelpPopup: false });
    }

    showSelectReasonsForContactPopup() {
        this.setState({ showSelectReasonsForContactPopup: true });
    }

    hideSelectReasonsForContactPopup(selectedReasonForContact) {
        this.setState({ showSelectReasonsForContactPopup: false });

        if (((!selectedReasonForContact || selectedReasonForContact.length === 0) &&
            (!this.state.selectedReasonForContact || this.state.selectedReasonForContact.length === 0)) ||
            (selectedReasonForContact && this.state.selectedReasonForContact &&
                selectedReasonForContact.id === this.state.selectedReasonForContact.id)) {
            return;
        }

        if (!arrayIsNotEmpty(selectedReasonForContact)) {
            this.setState({ selectedReasonForContact: undefined });
        }
        else {
            this.setState({ selectedReasonForContact: selectedReasonForContact[0] });
        }

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity));
    }

    showSelectChannelPopup() {
        this.setState({ showSelectChannelPopup: true });
    }

    hideSelectChannelPopup(selectedChannel) {
        this.setState({ showSelectChannelPopup: false });

        if (((!selectedChannel || selectedChannel.length == 0) &&
            (!this.state.selectedChannel || this.state.selectedChannel.length == 0)) ||
            (selectedChannel && this.state.selectedChannel &&
                selectedChannel.id == this.state.selectedChannel.id)) {
            return;
        }

        if (!arrayIsNotEmpty(selectedChannel)) {
            this.setState({ selectedChannel: undefined });
        }
        else {
            this.setState({ selectedChannel: selectedChannel[0] });
        }

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        const selectedChannelId = arrayIsNotEmpty(selectedChannel) ? selectedChannel[0].id : undefined;
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;

        const teamIds = this.state.selectedTeams ? this.state.selectedTeams.map(st => st.id) : undefined;
        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
            teamIds, selectedReasonForContactId, selectedChannelId));
    }

    getSelectedReasonForContactNode() {
        if (!this.state.selectedReasonForContact)
            return undefined;

        return this.getSelectedNode(filterType.reasonForContact, this.state.selectedReasonForContact, this.removeReasonForContact);
    }

    getSelectedChannelNode() {
        if (!this.state.selectedChannel)
            return undefined;

        return this.getSelectedNode(filterType.channel, this.state.selectedChannel, this.removeChannel);
    }

    removeAgent(id) {
        if (!this.state.selectedAgents || this.state.selectedAgents.length === 0)
            return;

        let teamIds;

        if (this.state.selectedAgents.length === 1) {
            this.setState({ selectedAgents: undefined });
        }
        else {
            const selectedAgentWithoutCurrent = this.state.selectedAgents.filter(t => t.id != id);
            this.setState({ selectedAgents: selectedAgentWithoutCurrent });
            teamIds = selectedAgentWithoutCurrent ? selectedAgentWithoutCurrent.map(st => st.id) : undefined;
        }

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;
        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
            teamIds, selectedReasonForContactId));
    }

    removeReasonForContact() {
        this.setState({ selectedReasonForContact: undefined });
        const selectedChannelId = this.state.selectedChannel ? this.state.selectedChannel.id : undefined;

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        const teamIds = this.state.selectedAgents ? this.state.selectedAgents.map(st => st.id) : undefined;
        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
            teamIds, undefined, selectedChannelId));
    }

    removeChannel() {
        this.setState({ selectedChannel: undefined });
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;

        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));
        const teamIds = this.state.selectedTeams ? this.state.selectedTeams.map(st => st.id) : undefined;
        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, this.state.selectedTimePeriodicity,
            teamIds, selectedReasonForContactId, undefined));
    }

    setNewTimeRangeForProgressOverTime(fromDate, toDate) {
        this.setState({ fromDate: fromDate, toDate: toDate });
        this.props.onSelectNewTimeRange(fromDate, toDate, this.state.selectedTimePeriodicity);
    }

    onSelectNewTimePeriodicity(selectedOption) {
        this.props.dispatch(updateProps({ progressOverTimeStats: undefined }));

        this.props.dispatch(loadProgressOverTimeStats(this.state.fromDate, this.state.toDate, selectedOption.id, undefined, undefined));

        this.setState({ selectedTimePeriodicity: selectedOption.id });
    }

    getSelectedNode(filterType, selectedValue, onClick) {
        let valueAndCloseIcon = (<>
            <p className="H3_14 black-text" style={{ margin: '0 8px 0 8px' }} >{selectedValue.value}</p>
            <HighlightOffIcon onClick={() => onClick(selectedValue.id)} style={{ margin: '0 0 0 4px', color: '#98DDE1' }} />
        </>);
        return (
            <div className="selected-node" key={selectedValue.id}>
                <p className="H3_14 orange-text" style={{ margin: '0 8px 0 8px' }} > {filterType}</p> <FilterArrow />
                {valueAndCloseIcon}
            </div>);
    }

    getSelectReasonForContactPopup() {
        const
            {
                reasonsForContact,
            } = this.props;

        if (!reasonsForContact)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    title="Select a reason for contact:"
                    searchPlaceHolder="Search..."
                    options={reasonsForContact}
                    onClose={this.hideSelectReasonsForContactPopup} />
            </div>
        </div>);
    }

    getSelectChannelPopup() {
        const
            {
                channels,
            } = this.props;

        if (!channels)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectReasonForContact">
                <SelectTable
                    title="Select a channel:"
                    searchPlaceHolder="Search..."
                    options={channels}
                    onClose={this.hideSelectChannelPopup} />
            </div>
        </div>);
    }

    getDateFiltersNode() {
        return (<div className="flex-container-start">
            <div style={{ margin: '0 0 0 20px' }}>
                <DateRangePicker
                    onClose={this.setNewTimeRangeForProgressOverTime} />
            </div>
        </div>);
    }

    onSelectDateRange({ currentTarget }) {
        if (!currentTarget || !currentTarget.options || typeof currentTarget.options.selectedIndex === 'undefined')
            return;

        let fromDate;
        let toDate = moment().format(dateFormat);
        if (currentTarget.options.selectedIndex === 0) {
            fromDate = moment().subtract(7, 'd').format(dateFormat);
        }
        else if (currentTarget.options.selectedIndex === 1) {
            fromDate = moment().subtract(30, 'd').format(dateFormat);
        }
        this.setState({ fromDate, toDate });
        const selectedReasonForContactId = this.state.selectedReasonForContact ? this.state.selectedReasonForContact.id : undefined;
        const selectedChannelId = this.state.selectedChannel ? this.state.selectedChannel.id : undefined;
        const teamIds = this.state.selectedAgents ? this.state.selectedAgents.map(st => st.id) : undefined;
        this.props.onSelectNewTimeRange(fromDate, toDate, selectedReasonForContactId, selectedChannelId, teamIds);
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                jibeProgressOverTimeStats
            } = this.props;

        const dateFiltersNode = this.getDateFiltersNode();
        const progressOverTimeHelp = "View how your team’s Jibe performance has progressed over time.";
        if (!arrayIsNotEmpty(calibratedOnSurveyQuestions)) {
            return <div></div>
        }

        return (
            <Tabs defaultIndex={1}>
                <TabList>
                    <Tab>
                        <div className="flex-container-center description-title">
                            <div>Progress Over Time</div>
                            <div className="flex-container-center" style={{ marginLeft: '5px' }}>
                                <HelpOutline onClick={this.showProgressOverTimeHelpPopup} />
                            </div>
                        </div>
                        {
                            this.state.showProgressOverTimeHelpPopup &&
                            <PopupCustomized
                                x={this.state.mouseClickX}
                                y={this.state.mouseClickY}
                                Message={progressOverTimeHelp}
                                close={this.closeProgressOverTimeHelpPopup} />
                        }
                    </Tab>
                </TabList>

                <TabPanel style={{ height: '518px', position: 'relative' }}>
                    <div className="flex-container flex-flex-end" style={{ margin: '20px' }}>
                        {dateFiltersNode}
                    </div>
                    <div className="graphs" style={{ boxShadow: 'none', marginTop: '8px' }}>
                        <GeneralQuestionCodeChartContainer
                            valueType="overalSuccessRatePercent"
                            maxX={110}
                            suffixY=" %"
                            chartType="spline"
                            calibratedOnSurveyQuestions={calibratedOnSurveyQuestions}
                            jibeProgressOverTimeStats={jibeProgressOverTimeStats}
                            propId="JibeProgressOverTimeChart12" />
                    </div>
                </TabPanel>
            </Tabs >);
    }
};

const select = state => ({ ...state.CalibrationV3Screen });
export default connect(select)(TeamOverTimeGraphs);

